import { removeNullOrUndefinedKeys } from '@/shared/helpers/object';

import { FilterSelections } from './types';

export const getOpenKeysFromSelections = <KeyT extends string>(
  selections: FilterSelections<KeyT> = {},
) => Object.keys(removeNullOrUndefinedKeys(selections));
